import { select, call, takeLeading, put } from 'redux-saga/effects';
import { Toaster, Intent, Position } from '@blueprintjs/core';

import * as $ui from 'modules/ui';
import { UI } from 'modules/ui';
import * as $auth from 'modules/auth';
import * as api from '../api';
import * as actions from '../actions';

const InfluencersToaster = Toaster.create({
  position: Position.BOTTOM_RIGHT,
});

const refetchInfluencers = function* () {
  const queryParams = new URLSearchParams(window.location.search);
  const pageSize = queryParams.get('pageSize') || 20;
  const pageNumber = 1;

  yield put(actions.fetchInfluencers(pageSize, pageNumber));
};

const deleteInfluencer = function* ({ payload }) {
  const { id } = payload;

  const token = yield select($auth.getToken);
  const publisherId = yield select($auth.getSelectedPublisherId);

  try {
    yield put($ui.setUi(UI.Influencers.IsDeleting, id));

    yield call(api.deleteInfluencer, id, {
      token,
      publisherId,
    });

    yield call(refetchInfluencers);
  } catch (error) {
    InfluencersToaster.show({
      icon: 'warning-sign',
      intent: Intent.DANGER,
      message: 'Something went wrong while deleting the influencer',
    });
  } finally {
    yield put($ui.setFalse(UI.Influencers.IsDeleting)());
  }
};

export const deleteInfluencerSaga = function* () {
  yield takeLeading(actions.deleteInfluencer, deleteInfluencer);
};
